import React, {useEffect} from 'react';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import './index.scss';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toasterConfig, imageExtension } from "../../../../../utils/constants";
import { capitalizeFirstLetter } from "../../../../../utils/common";
import { validationMessage  } from "../../../../../utils/validation";
import { uploadProfileImage,deleteProfileImage } from "../../../../../context/actions/user";
import UserPlaceholder from '../../../../../components/common/UserPlaceholder';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { useState } from 'react';
const MySwal = withReactContent(Swal);


const ProfileImage = () => {
    const dispatch = useDispatch();
    const userDetail = useSelector((state) => state?.user?.user);
    const [subadminDisabled, setSubadminDisabled] = useState(false)
    /**
   * @description method use to check file type
   * @param {object} 
   */
  const fileCheckImg = (obj) => {
      
    var fileExtension = imageExtension;
    if (obj) {
      if (!fileExtension.includes(obj.name.split('.').pop())) {
        return true;
      }
      return false;
    }
    return false;
  }

       // On file select (from the pop up)
     const onFileChange = event => {
        var result = fileCheckImg(event.target.files[0]);
         if (!result) {
                 let formData = new FormData();
                 formData.append(`logo`, event.target.files[0]);
                 formData.append(`fname`, userDetail?.fname);
                 dispatch(uploadProfileImage(formData, userDetail?._id, (res) => {
                 }))
         } else {
             toast.error(validationMessage.imageReq, toasterConfig);
         }
      };
    

    /**
      * @description method call delete image api
      */
    const _delete = () => {
        MySwal.fire({
            title: 'Are you sure?',
            text: "You want to delete image",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
            dispatch(deleteProfileImage((res) => {
                }))
            }
           
        })
    }

    useEffect(()=>{
        if(userDetail?.role == "superadmin" || userDetail?.role == "subadmin"){
            setSubadminDisabled(true)
        }
      }, [userDetail])
    return (
        <div className="user-image-blc text-center">
            <div className="pic">
                <div className="inner d-inline-flex">
                     {userDetail?.blob_name ?
                            <img className='img-fluid rounded-circle' src={userDetail.blob_name} alt='User' />
                            : <UserPlaceholder />
                        }
                </div>
                <label className="pic-lbl d-block">
                 {userDetail?.fname && capitalizeFirstLetter(userDetail?.fname) + ' ' + (userDetail?.lname && capitalizeFirstLetter(userDetail?.lname))}
                </label>
            </div>

            <div className="btn-cell">
                <Button disabled={subadminDisabled} type="button" color='secondary' className='upload-file-btn position-relative'>
                    <input name="logo" type="file" className='position-absolute' onChange={onFileChange} />
                    Upload Photo
                </Button>
                {userDetail?.blob_name &&  <Button type="button" id="delete" name="delete" onClick={_delete} color='danger' disabled={subadminDisabled}>Delete</Button> } 
            </div>
        </div>
    );
}

export default ProfileImage;